import React from "react";
import PropTypes from "prop-types";
import { loadCSS } from "fg-loadcss/src/loadCSS";
import { withStyles } from "@material-ui/core/styles";
import FolderIcon from "@material-ui/icons/Folder";
import DeleteIcon from "@material-ui/icons/Delete";

import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import { Modal, ModalBody, Spinner } from "reactstrap";

import {
    Avatar,
    Typography,
    FormControl,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Snackbar,
    SnackbarContent,
    Button,
    IconButton,
    ListItemSecondaryAction,
    List,
    Paper
} from "@material-ui/core";

import { connect } from "react-redux";
import { getUploadedFiles, gotolink, uploadFile, removeFile } from "./actions";
import { selectUploadedFiles, getRequesting,canCreate,canDelete } from "./selectors";
import "react-day-picker/lib/style.css";

const styles = (theme) => ({
    "*": {
        transition: ".3s ease-in-out",
        overflow: "visible",
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)",
    },
    bigAvatar: {
        width: "50%",
        height: "auto",
        display: "block",
        margin: "0 auto",
        position: "relative",
    },

    actions: {
        display: "flex",
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: "auto",
    },

    icon: {
        width: "auto",
        color: "inherit",
    },
    card: {
        fontSize: 18,
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: "56.25%", // 16:9
    },
    expandOpen: {
        transform: "rotate(180deg)",
    },

    button: {
        margin: 10,
    },
    textField: {
        margin: 20,
        width: "75%",
    },
    form: {
        margin: 20,
        width: "75%",
    },
    picker: {
        fontSize: "12px",
    },
    paper: {
        padding: 12,
    },
    tabTitle: {
        width: "100%",
        boxShadow: "none",
    },
    tabText: {
        color: "white",
    },
    bgGreen: {
        backgroundColor: "green",
    },
    bgAmber: {
        backgroundColor: "orange",
    },
    bgRed: {
        backgroundColor: "red",
    },
    stepContainer: {
        overflow: "visible",
    },
    stepItem: {
        overflow: "visible",
    },
    activeTab: {
        backgroundColor: "rgb(63,81,181)",
        borderRadius: 8,
        color: "white",
        "&:hover": {
            backgroundColor: "rgb(63,81,211)",
        },
    },
    hr: { color: "#bbb", backgroundColor: "#bbb", border: "#bbb" },
    tab: {
        borderRadius: 8,
        color: "grey",
    },
    table: {
        border: "1px solid #cccccc",
        borderRadius: 4,
    },
    toggleContainer: {
        height: 56,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: `${theme.spacing.unit}px 0`,
        background: theme.palette.background.default,
    },
});

class CompanyPolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileSuccess: false,
            deleteSuccess: false,
            fileUploading: false,
            fileProgress: false,
            success: false,
            files: [],
            alertOpen: false,
            modelOpen: false,
            selectedFile: false,
            uuid: [],

            spacing: 16,
        };
        props.getUploadedFiles();
    }
    componentDidMount() {
        loadCSS(
            "https://use.fontawesome.com/releases/v5.1.0/css/all.css",
            document.querySelector("#insertion-point-jss")
        );
    }
    componentDidUpdate(prevProps, prevState) {}
    handleFileUploader = (event) => {
        Object.keys(event.target.files).map((e) => {
            this.props.uploadFile(
                event.target.files[e],
                this.props.uploadedFiles,
                (status) => {
                    if (status.inProgress) {
                        this.setState({ fileProgress: status.progress });
                    } else if (status.finished) {
                        this.setState({
                            fileSuccess: true,
                            fileProgress: false,
                        });
                    } else if (status.error) {
                    }
                }
            );
            return null;
        });
    };

    handleFileRemove(filename, i) {
        this.props.removeFile(filename, this.props.uploadedFiles, i);
    }

    reachedLimit = () => {
        //check if props loaded
        if (this.props.uploadedFiles === null) return true;

        if (this.props.uploadedFiles.length > 4) return false;
        else return true;
    };

    onFormSubmit = () => {};
    goToLink = (url) => this.props.gotolink(url);
    render() {
        const { classes } = this.props;

        const files =
            this.props.uploadedFiles === false ? [] : this.props.uploadedFiles;
        return (
            <StyledCard>
                <Modal isOpen={this.state.modelOpen}>
                    <Paper style={{ padding: 15 }}>
                        <Typography
                            style={{ marginBottom: 15 }}
                            variant="title"
                        >Delete Files
                        </Typography>
                                <Typography
                                    style={{ margin: 15 }}
                                    variant="body2"
                                >
                                    <b>
                                        This will delete files permanently!!
                                    </b>
                                </Typography>
                               
                            

                        <div style={{ float: "right", margin: 10 }}>
                            <Button
                                onClick={() => this.setState({ modelOpen: false })}
                                color="primary"
                                style={{ marginRight: 5 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                color= "secondary"
                                variant="contained"
                                onClick={() => {
                                    this.handleFileRemove(
                                        this.state.selectedFile,
                                        files
                                    );
                                    this.setState({ modelOpen: false, deleteSuccess: true })
                                }}
                                >
                                    Delete
                                </Button>
                            
                        </div>
                    </Paper>
                
            </Modal>
                <div>
                    <form>
                        <StyledHeader>
                            <Typography variant="h5">
                                Company Policies
                            </Typography>
                        </StyledHeader>
                        <StyledContent>
                            <StyledViewContainer>
                                {files === null ? (
                                    <Modal
                                        isOpen={this.props.requesting}
                                        style={{ maxWidth: "00px" }}
                                    >
                                        <ModalBody>
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    paddingTop: "3em",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        background: "white",
                                                        width: "fit-content",
                                                        display: "inline-block",
                                                        padding: "2em",
                                                    }}
                                                >
                                                    <Spinner
                                                        style={{
                                                            height: 100,
                                                            width: 100,
                                                            background: "white",
                                                        }}
                                                        color="primary"
                                                    />
                                                    <Typography
                                                        style={{
                                                            textAlign: "center",
                                                            marginTop: 15,
                                                            color:
                                                                "rgba(0, 0, 0, 0.87)",
                                                            fontWeight:
                                                                "bolder",
                                                            fontSize: 20,
                                                        }}
                                                        variant="body2"
                                                    >
                                                        Processing...
                                                    </Typography>
                                                </div>
                                            </div>
                                        </ModalBody>
                                    </Modal>
                                ) : (
                                    ""
                                )}

                                <div>
                                    <FormControl className={classes.form}>
                                        {this.state.fileProgress !== false && (
                                            <p
                                                style={{
                                                    width: "100%",
                                                    background: "orange",
                                                    padding: "1em",
                                                    color: "white",
                                                    fontWeight: "600",
                                                    borderRadius: 4,
                                                }}
                                            >
                                                File Upload Progress:{" "}
                                                {this.state.fileProgress}%
                                            </p>
                                        )}

                                        <input
                                            accept="application/pdf"
                                            multiple
                                            type="file"
                                            onChange={this.handleFileUploader}
                                            style={{ display: "none" }}
                                            ref={(fileInput) =>
                                                (this.fileInput = fileInput)
                                            }
                                        />
                                        <Typography>
                                            {this.state.uploadFileName}
                                        </Typography>
                                        <Button
                                        disabled={this.props.canCreate===false}
                                            color="primary"
                                            style={{
                                                width: "180px",
                                                display: "inline",
                                            }}
                                            onClick={() => {
                                                this.fileInput.click();
                                            }}
                                            variant="contained"
                                            className={classes.button}
                                        >
                                            Select File(s)
                                        </Button>
                                    </FormControl>
                                </div>
                                <Typography
                                    variant="h5"
                                    className={classes.title}
                                >
                                    Uploaded Files:
                                </Typography>
                                <div>
                                    <List dense={true}>
                                        {files &&
                                            files.map((e, i) => {
                                                return (
                                                    <ListItem
                                                        key={i}
                                                        onClick={() => {
                                                            this.goToLink(
                                                                `/pdf-viewer/company_policies/${i}`
                                                            );
                                                        }}
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <FolderIcon />
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={e["file"]}
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <IconButton
                                                            disabled={this.props.canDelete===false}
                                                                aria-label="Delete"
                                                                onClick={() => {
                                                                    this.setState({ modelOpen: true, selectedFile : i });
                                                                }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                );
                                            })}
                                    </List>
                                </div>
                            </StyledViewContainer>
                        </StyledContent>
                    </form>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        autoHideDuration={6000}
                        open={this.state.fileSuccess || this.state.deleteSuccess}
                        onClose={() => {
                            this.setState({ fileSuccess: false });
                        }}
                    >
                        <SnackbarContent
                            style={{ backgroundColor: "green", color: "white" }}
                            message={
                                this.state.fileSuccess
                                    ? "File has been successfully uploaded!"
                                    : "File has been deleted successfully!"
                            }
                        />
                    </Snackbar>
                </div>
            </StyledCard>
        );
    }
}
CompanyPolicy.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default connect(
    (store) => {
        return {
            uploadedFiles: selectUploadedFiles(store),
            requesting: getRequesting(store),
            canCreate:canCreate(store),
            canDelete:canDelete(store)
        };
    },
    {
        uploadFile,
        removeFile,
        gotolink,
        getUploadedFiles,
    }
)(withStyles(styles)(CompanyPolicy));
